/// <reference path="functions.ts" />

module Constants {
    export var debug = true

    export var broadcast = {
        loading: {
            show: 'loading:show',
            hide: 'loading:hide'
        },
        compositionChange: 'compositionChanged',
        shopcartUpdated: 'shopcartUpdated',
        shopcartUpdatedFromCart: 'shopcartUpdatedFromCart',
        validateStep: 'validateStep',
        stepNameValidated: 'stepNameValidated',
        validateTimerSet: 'validateTimerSet'
    }

    export var loggedInRootRouteKey = 'user'
    export var routeKeys = {
        default: 'default',
        cardetail: 'cardetail',
        products: 'products',
        appointment: 'appointment',
        contact: 'contact',
        contactShort: 'contactshort',
        overview: 'overview',
        saved: 'saved',
        tyrechange: 'tyrechange',
        notyrechange: 'notyrecontact',
        carcheck: 'carCheck',
    }

    export var websiteHostUrl = (location.origin || location.protocol + '//' + location.host) + '/'
    export var websiteApiBaseUrl: string = websiteHostUrl + 'umbraco/api/'
    export var websiteUrlCalls = {
        setState: websiteApiBaseUrl + 'CompositionApi/SetState',
        getSteps: websiteApiBaseUrl + 'CompositionApi/getMenuSteps',
        getFormInfo: websiteApiBaseUrl + 'CompositionApi/getFormInfo',
        getReplacementVehicleTexts: websiteApiBaseUrl + 'CompositionApi/replacementVehicleTexts',
        postCodeRequest: websiteApiBaseUrl + 'Postalcode/GetAddress',
        getUser: websiteApiBaseUrl + 'UserApi/GetUser',
        getOpenIdConfig: websiteApiBaseUrl + 'UserApi/GetOpenIdConfig',
        addUser: websiteApiBaseUrl + 'UserApi/AddUser',
        storeFirstDateRequest: websiteApiBaseUrl + 'CompositionApi/GetFirstAvailableDate',
    }

    export var httpMethods = {
        GET: 'GET',
        POST: 'POST'
    }

    export var defaultStepNumber = 2

    export var resetTimes = {
        soft: 3,
        total: 4
    }

    export var viewRegions = {
        body: 'pageContent',
        appContent: 'appContent',
    }

    export var loadingTimeOut: number = 300

    export var defaultStoreText: string = 'Selecteer vestiging'
    export var defaultTimeText: string = 'Kies een tijd'
    export var defaultReplacementVehicleText: string = 'Kies vervangend vervoer'
    export var defaultSalutation: string = 'Aanhef *'

    export var maintenanceProductTxt: string = 'beurt'

    export var apiServiceStateCalls = {
        license: 'licensePlate',
        mileage: 'mileage',
        storeId: 'storeId',
        selectedProducts: 'selectedProducts',
        needReplacement: 'needReplacement',
        selectedReplacementVehicle: 'selectedReplacementVehicle',
        selectedDate: 'selectedDate',
        postalCode: 'postalCode',
        telephone: 'telephone',
        discountVoucher: 'selectedDiscountVoucher',
        privacyCheck: 'privacyCheck',
        waitForJob: 'waitForJob'
    }

    export var regexExp = {
        email: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
        postcode: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
    }

    export var productTypes = {
        maintenance: '1',
        actions: '2'
    }

    export var licenseTxt = 'VUL-KENTEKEN-IN'

    export var noMaintenanceProductName = 'geen onderhoud'
    export var replacementVehiclePickupTermOne = 'haal'
    export var replacementVehiclePickupTermTwo = 'breng'
    export var emptyGroupName = 'Werkzaamheden'

    export var configuratorTypes = {
        standardProductPipelineName: "standard",
        summerWinterCheckPipelineName: "summerwintercheck",
        tyreChangeAaPipelineName: "tyrechange-aa",
        tyreChangeDefaultPipelineName: "tyrechange-default",
        tyreChangePipelineName: "tyrechange-only"
    }

    export var customCarBrandHolder: string = "Auto merk"
    export var customFuelTypeHolder: string = "Brandstof"

    export var encryptionKey = "77397A2443264629"
    export var encryptionIV = "782F413F4428472D"

    export var apkProductSearchPhrase = "apk"

    export var expectYourCarTextWithTime = "We verwachten uw auto graag om {0}."
    export var expectYourCarText: string = "We verwachten uw auto graag tussen 8:00 en 9:00. Op zaterdag vanaf 09:00."
    export var waitForSearchPhrase = "wachten"
}